export default __webpack_public_path__ + "static/media/sponser.c0aec8d8.jpg";